import { Component, OnInit, OnDestroy, AfterViewInit, ViewEncapsulation, ViewChild, OnChanges } from '@angular/core';
import { fuseAnimations } from '@fuse/animations';
import { FuseCardModule } from '@fuse/components/card';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subject } from 'rxjs';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as en } from './i18n/en';
import { locale as zh } from './i18n/zh';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { CaseCount } from '@app/core/models/dashboard.model';
import { Deparment } from '@app/core/models/department.model';
import { FeatureAccessService } from '@app/core/services/feature-access.service';
import { RequestService } from '@app/core/services/request.service';
import { AuthService } from '@app/core//services/auth.service';
import { DepartmentService } from '@app/core/services/department.service';
import { map } from 'rxjs/operators';

import * as _ from 'lodash';
import { IQuery } from '@app/core/models/query.model';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    animations: fuseAnimations,
    encapsulation: ViewEncapsulation.None
})
export class HomeComponent implements OnInit, OnDestroy, OnChanges {
    features: string[];
    private unsubscribeAll: Subject<any>;
    form: FormGroup;

    caseCount: CaseCount = {};
    caseQuery: IQuery = {};;
    departments: Deparment[] = [];;
    /* departmentsField: FormControl; */
    department: number;
    query: IQuery = {};
    loading = false;

    constructor(
        private fuseTranslationLoaderService: FuseTranslationLoaderService,
        private authService: AuthService,
        private requestService: RequestService,
        private departmentService: DepartmentService,
        private formBuilder: FormBuilder,
        private snackBar: MatSnackBar,
    ) {
        this.fuseTranslationLoaderService.loadTranslations(en, zh);
        this.unsubscribeAll = new Subject();
        this.form = this.formBuilder.group({
            departmentsField: new FormControl()

        });
        
    }

    ngOnInit(): void {
        const user = this.authService.currentUser();
        this.features = user.feature_access;
        this.loadPage();

        this.departmentService
            .listingByMe({                
                meta: { per_page: 999999 },
            })
            .subscribe((data) => {
                this.departments = data || [];
            });

    }

    ngOnChanges(): void {
        this.department = this.form.get('departmentField').value;
        console.log(this.department);
    }

    setDepartment(department: number) {
        this.department = department;
        this.loadPage();
    }

    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    loadPage(): void {
        this.query.match = new Map<string, any>([
            ['department', this.department]
        ]);
        setTimeout(() => {
            this.loading = true;
        });
        this.requestService.caseCount(this.query)
        .subscribe(data => {
            setTimeout(() => {
                if (data !== null && data !== undefined) {
                    this.caseCount = data;
                }
            }, 300);
        },
        error => {
            this.showErrorMessage(error.parsedMessage);
        });
    }

    private showErrorMessage(error): void {
        this.snackBar.open(error, '', {
            duration: 3000,
            panelClass: ['warn']
        });
    }

}
